import {create} from 'zustand/react';
import type {PlaylistInfo} from '../pages/replay/types';
import {persist} from 'zustand/middleware';

interface IDiskUsage {
    free: number;
    total: number;
}

interface IYTdownloadStore {
    diskUsage: IDiskUsage;
    setDiskUsage: (val: IDiskUsage) => void;
    downLoadedVideos: Array<PlaylistInfo>;
    addDownLoadedVideos: (val: PlaylistInfo) => void;
    setDownLoadedVideos: (val: Array<PlaylistInfo>) => void;
    deleteDownLoadedVideos: (id: string) => void;
    downloadProgress: Record<string, number>;
    setDownloadProgress: (id: string, val: number) => void;
    startDownload: (videoInfo: PlaylistInfo) => void;
}

const useYTdownloadStore = create<IYTdownloadStore>()(
    persist(
        (set, get) => ({
            diskUsage: {free: 0, total: 1},
            setDiskUsage: (val) => {
                set({diskUsage: val});
            },
            downLoadedVideos: [],
            addDownLoadedVideos: (val) => {
                set((state) => ({
                    downLoadedVideos: [...state.downLoadedVideos, val],
                }));
            },
            setDownLoadedVideos: (val) => {
                set({downLoadedVideos: val});
            },
            deleteDownLoadedVideos: (id: string) => {
                set((state) => ({
                    downLoadedVideos: state.downLoadedVideos.filter((item) => item.id !== id),
                }));
            },
            downloadProgress: {},
            setDownloadProgress: (id, val) => {
                set((state) => ({
                    downloadProgress: {
                        ...state.downloadProgress,
                        [id]: val,
                    },
                }));
            },
            startDownload: (videoInfo: PlaylistInfo) => {
                const {setDownloadProgress, addDownLoadedVideos, setDiskUsage, diskUsage} = get();
                const id = videoInfo.id;

                setDownloadProgress(id, 0);
                let progress = 0;
                const interval = setInterval(() => {
                    progress += Math.floor(Math.random() * (5 - 2 + 1)) + 2;
                    if (progress >= 100) {
                        progress = 100;
                        clearInterval(interval);
                        addDownLoadedVideos(videoInfo);
                        const dummySize = 2000 * 1024 * 1024;
                        const newUsage = diskUsage.free - dummySize;
                        setDiskUsage({free: newUsage, total: diskUsage.total});
                    }
                    setDownloadProgress(id, progress);
                }, 1000);
            },
        }),
        {
            name: 'yt-download-storage',
        }
    )
);

export default useYTdownloadStore;
